import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request table view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const url =
            devConfig.geturlApi() + // API URL for fetching withdrawal requests
            'es/Client/GetClientWithdrawalRequestsBetShop';

        // Custom data filter for summing column values
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold formatted result
                    var size = $$('table').getPager().config.size; // Get page size
                    var page = $$('table').getPage(); // Get current page
                    var first = size * page; // Calculate first item index
                    var last = first + size - 1; // Calculate last item index
                    var count = 0; // Counter for items

                    // Iterate through master data to calculate sum
                    master.data.each(function (obj) {
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Sum the values
                        }
                        count++;
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        return {
            rows: [
                {
                    id: 'preloader', // ID for preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'table', // ID for the table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            checkboxRefresh: true, // Enable checkbox refresh
                            height: screen.width < 500 ? 410 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'detailTittle', // Column ID for details
                                    header: "<span placeholder='Aprobar' class='webix_icon wxi-close approvecheck'></span>", // Header with icon
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Detalles', // Tooltip text
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Template for details icon
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'ch1', // Checkbox column ID
                                    header: { content: 'masterCheckbox' }, // Header content
                                    checkValue: 'on', // Value when checked
                                    uncheckValue: 'off', // Value when unchecked
                                    width: 40, // Column width
                                    template: function (obj, type, value, config, i) {
                                        // Template for checkbox rendering
                                        if (
                                            (obj.State == 'A' &&
                                                obj.AccountBank !== '' &&
                                                obj.AccountBank !== undefined &&
                                                obj.AccountBank !== null) ||
                                            (obj.State == 'M' &&
                                                (obj.AccountBank == '' ||
                                                    obj.AccountBank == undefined ||
                                                    obj.AccountBank == null))
                                        ) {
                                            if (value == 'on') {
                                                return (
                                                    `<input value=` +
                                                    obj.Id +
                                                    ` class="webix_table_checkbox" type="checkbox" checked="true">`
                                                ); // Render checked checkbox
                                            } else {
                                                return (
                                                    `<input value=` +
                                                    obj.Id +
                                                    ` class="webix_table_checkbox" type="checkbox">`
                                                ); // Render unchecked checkbox
                                            }
                                        } else {
                                            return ``; // No checkbox rendered
                                        }
                                    },
                                },
                                {
                                    id: 'ActionTittle', // Column ID for actions
                                    header: '', // No header text
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip text
                                    template: function (obj) {
                                        // Template for action buttons
                                        if (
                                            (obj.State == 'A' &&
                                                obj.AccountBank !== '' &&
                                                obj.AccountBank !== undefined &&
                                                obj.AccountBank !== null) ||
                                            (obj.State == 'M' &&
                                                (obj.AccountBank == '' ||
                                                    obj.AccountBank == undefined ||
                                                    obj.AccountBank == null))
                                        ) {
                                            if (devConfig.getPermAction('withdrawalRequestsApprove', 'Approve')) {
                                                return "<span placeholder='Aprobar' class='webix_icon wxi-close approve prm-withdrawalRequestsApprove'></span><span class='webix_icon wxi-close torefuse prm-withdrawalRequestsApprove'></span>"; // Approve and refuse buttons
                                            }
                                        } else {
                                            if (
                                                obj.State == 'P' &&
                                                obj.AccountBank !== '' &&
                                                obj.AccountBank !== undefined &&
                                                obj.AccountBank !== null
                                            ) {
                                                if (devConfig.getPermAction('withdrawalRequestsPay', 'Pay')) {
                                                    return "<span placeholder='Pagar' class='webix_icon wxi-close pay prm-withdrawalRequestsPay'></span><!--<span class='webix_icon wxi-close torefuse'></span>-->"; // Pay button
                                                }
                                            } else {
                                                return ''; // No buttons rendered
                                            }
                                        }
                                        return ''; // Default return
                                    },
                                },
                                {
                                    id: 'CreatedLocal', // Column ID for creation date
                                    header: _('Fecha Creación'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Header text
                                    options: [
                                        { id: '', value: _('None') }, // Option for no state
                                        { id: 'A', value: _('Activado') }, // Option for activated
                                        { id: 'C', value: _('Cancelado') }, // Option for canceled
                                        { id: 'I', value: _('Pagada') }, // Option for paid
                                        { id: 'E', value: _('Eliminado') }, // Option for deleted
                                        { id: 'P', value: _('Pendiente') }, // Option for pending
                                        { id: 'R', value: _('Rechazado') }, // Option for rejected
                                        {
                                            id: 'S',
                                            value: _('Pendiente Sistema'), // Option for system pending
                                        },
                                    ],
                                },
                                {
                                    id: 'PaymentDate', // Column ID for payment date
                                    header: _('Fecha Pagado'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Header text
                                    format: webix.i18n.priceFormat, // Formatting function
                                    footer: { content: 'mySummColumn' }, // Footer content
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: 'Id', // Header text
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID for client ID
                                    header: _('ID Cliente'), // Header text
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'WayPay', // Column ID for payment method
                                    header: _('Forma de pago'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PaymentMethod', // Column ID for payment method
                                    header: _('Método de pago'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeAccount', // Column ID for account type
                                    header: _('Tipo de cuenta'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AccountBank', // Column ID for bank account
                                    header: _('Cuenta Bancaria'), // Header text
                                    exportType: 'string', // Export type
                                    width: 220, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CodeInterbank', // Column ID for interbank code
                                    header: _('Código Interbancario'), // Header text
                                    exportType: 'string', // Export type
                                    width: 220, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'VerifdniAnt', // Column ID for DNI verification
                                    header: _('DNI'), // Header text
                                    exportType: 'string', // Export type
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeDocument', // Column ID for document type
                                    header: _('Tipo Documento'), // Header text
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Identification', // Column ID for identification
                                    header: _('Cedula'), // Header text
                                    exportType: 'string', // Export type
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientName', // Column ID for client name
                                    header: _('Nombre Cliente'), // Header text
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Email', // Column ID for email
                                    header: _('Email'), // Header text
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Country', // Column ID for country
                                    header: _('País'), // Header text
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.Country + "'></i>" // Template for country flag
                                        );
                                    },
                                },
                                {
                                    id: 'Department', // Column ID for department
                                    header: _('Departamento'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'City', // Column ID for city
                                    header: _('Ciudad'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BetShopName', // Column ID for bet shop name
                                    header: _('Punto de Venta'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Ip', // Column ID for IP address
                                    header: 'IP', // Header text
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ChangeDate', // Column ID for change date
                                    header: _('Fecha Cambio'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ActionDate', // Column ID for action date
                                    header: _('Fecha Acción'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    $$('formDetails').clear(); // Clear details form
                                    $$('dColl').expand(); // Expand details section
                                    $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                },
                                pay: function (euv, id) {
                                    var vvthis = this; // Reference to the current instance
                                    webix
                                        .modalbox({
                                            title: _('Pregunta'), // Modal title
                                            buttons: [
                                                _('Pagar por Sistema'), // Button text
                                                _('Pagado fisicamente'), // Button text
                                                _('Rechazar nota de retiro'), // Button text
                                                _('Cancelar'), // Button text
                                            ],
                                            text: _('Elija la forma de pago'), // Modal text
                                            width: screen.width < 500 ? 300 : 500, // Modal width
                                            height: screen.width < 500 ? 200 : 0, // Modal height
                                        })
                                        .then(function (result) {
                                            switch (result) {
                                                case '0': // Pay by system
                                                    webix.confirm({
                                                        type: 'confirm-warning',
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'), // Confirmation text
                                                        ok: _('Pagar Nota'), // OK button text
                                                        cancel: _('Salir'), // Cancel button text
                                                        callback: function (action) {
                                                            if (action === true) {
                                                                var item = vvthis.getItem(id); // Get the item
                                                                if (item.AllowPayApi) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Client/PayWithdrawalRequestsAPI',
                                                                            '{ "Id":' + item.Id + '}', // Payload for API
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        _('Error! '), // Error message
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    item.State = 'S'; // Update item state
                                                                                    webix.message(
                                                                                        _(
                                                                                            'Envio de solicitud de pago. ',
                                                                                        ), // Success message
                                                                                    );
                                                                                    vthis.$$('table').refresh(); // Refresh the table
                                                                                },
                                                                            },
                                                                        );
                                                                } else {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Esta nota de retiro no tiene permitido el pago por sistema', // Error message
                                                                        ),
                                                                        title: _('¡Error!'), // Error title
                                                                        type: 'alert-error', // Alert type
                                                                    });
                                                                }
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '1': // Pay physically
                                                    webix.confirm({
                                                        type: 'confirm-warning',
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'), // Confirmation text
                                                        ok: _('Pagar Nota'), // OK button text
                                                        cancel: _('Cancelar'), // Cancel button text
                                                        callback: function (action) {
                                                            if (action === true) {
                                                                var item = vvthis.getItem(id); // Get the item
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Client/PayWithdrawalRequests',
                                                                        '{ "Id":' + item.Id + '}', // Payload for API
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(
                                                                                    _('Error! '), // Error message
                                                                                );
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'I'; // Update item state
                                                                                webix.message(
                                                                                    _(
                                                                                        'Nota de retiro pagada', // Success message
                                                                                    ),
                                                                                );
                                                                                vthis.$$('table').refresh(); // Refresh the table
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '2': // Reject withdrawal note
                                                    webix.confirm({
                                                        type: 'confirm-warning',
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Rechazar Nota de Retiro?'), // Confirmation text
                                                        ok: _('Rechazar Nota'), // OK button text
                                                        cancel: _('Salir'), // Cancel button text
                                                        callback: function (action) {
                                                            if (action === true) {
                                                                var item = vvthis.getItem(id); // Get the item
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Client/CancelClientRequests',
                                                                        '{ "Id":' + item.Id + '}', // Payload for API
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(
                                                                                    'Error! ', // Error message
                                                                                );
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'E'; // Update item state
                                                                                webix.message(
                                                                                    _(
                                                                                        'Nota de Retiro Rechazada', // Success message
                                                                                    ),
                                                                                );
                                                                                vthis.$$('table').refresh(); // Refresh the table
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '3': // Cancel action
                                                    break;
                                            }
                                        });
                                },
                                approve: function (euv, id) {
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Nota de Retiro?'), // Confirmation text
                                        ok: _('Aprobar Nota'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}', // Payload for API
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var resp = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (!resp.HasError) {
                                                                    item.State = resp.Data.State; // Update item state
                                                                    webix.message(
                                                                        _(
                                                                            'Nota de Retiro Aprobado', // Success message
                                                                        ),
                                                                    );
                                                                    vthis.$$('table').refresh(); // Refresh the table
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                torefuse: function (euv, id) {
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar Nota de Retiro?'), // Confirmation text
                                        ok: _('Rechazar Nota'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/CancelClientRequests',
                                                        '{ "Id":' + item.Id + '}', // Payload for API
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'E'; // Update item state
                                                                webix.message(
                                                                    _(
                                                                        'Nota de Retiro Rechazada', // Success message
                                                                    ),
                                                                );
                                                                vthis.$$('table').refresh(); // Refresh the table
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                approvecheck: function (euv, id) {
                                    var gridData = $$('table').data.pull; // Get table data
                                    var arrayCheckeds = []; // Array to hold checked IDs
                                    Object.values(gridData).forEach(function (currentValue, index, array) {
                                        if (currentValue.ch1 == 'on') {
                                            arrayCheckeds.push(
                                                currentValue.Id, // Add checked ID to array
                                            );
                                        }
                                    });
                                    if (arrayCheckeds.length > 0) {
                                        const params = {
                                            Ids: arrayCheckeds, // Parameters for API
                                        };
                                        webix.confirm({
                                            type: 'confirm-warning',
                                            text:
                                                _('Advertencia!') +
                                                '<br/>' +
                                                _('Desea aprobar notas de retiro seleccionadas?'), // Confirmation text
                                            ok: _('Aprobar Notas'), // OK button text
                                            cancel: _('Salir'), // Cancel button text
                                            callback: function (action) {
                                                if (action === true) {
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/AllowAllWithdrawalRequests',
                                                            params, // Parameters for API
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Error! ', // Error message
                                                                    );
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var resp = JSON.parse(
                                                                        text, // Parse response
                                                                    );
                                                                    if (!resp.HasError) {
                                                                        webix.message(
                                                                            _(
                                                                                'Notas de retiro aprobadas', // Success message
                                                                            ),
                                                                        );
                                                                        $$('table').clearAll(); // Clear table data
                                                                        $$('table').load(
                                                                            url +
                                                                                '?start=0&count=' +
                                                                                $$('table').data.$pagesize,
                                                                        ); // Reload table data
                                                                    } else {
                                                                        webix.alert({
                                                                            type: 'alert-error', // Alert type
                                                                            title: 'Error', // Alert title
                                                                            text: _('Error! '), // Alert text
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                        );
                                                }
                                            },
                                        });
                                    } else {
                                        webix.alert({
                                            type: 'alert-error', // Alert type
                                            title: 'Error', // Alert title
                                            text: _(
                                                'Seleccione por lo menos una nota de retiro para aprobar', // Alert text
                                            ),
                                        });
                                    }
                                },
                            },
                            editable: true, // Enable editing
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: $$('select').getValue(), // Load ahead value
                            footer: true, // Enable footer
                            pager: 'pagerA', // Pager ID
                            url: url, // Data URL
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        grid = $$('table'); // Reference to the table
        var url = grid.data.url; // Get the data URL
        var filter = ''; // Initialize filter variable

        // Event listener for filter updates
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    if (object[i][1] == 0) {
                        // Show specific columns based on filter type
                        grid.showColumn('Id', { spans: true });
                        grid.showColumn('ClientId', { spans: true });
                        grid.showColumn('ClientName', { spans: true });
                        grid.showColumn('VerifdniAnt', { spans: true });
                        grid.showColumn('CreatedLocal', { spans: true });
                        grid.showColumn('Department', { spans: true });
                        grid.showColumn('City', { spans: true });
                        grid.showColumn('BetShop', { spans: true });
                        grid.showColumn('WayPay', { spans: true });
                        grid.showColumn('AccountBank', { spans: true });
                        grid.showColumn('CodeInterbank', { spans: true });
                        grid.showColumn('Ip', { spans: true });
                        grid.showColumn('PaymentMethod', { spans: true });
                        grid.hideColumn('Country', { spans: true });
                    } else {
                        // Hide specific columns based on filter type
                        grid.hideColumn('Id', { spans: true });
                        grid.hideColumn('ClientId', { spans: true });
                        grid.hideColumn('ClientName', { spans: true });
                        grid.hideColumn('VerifdniAnt', { spans: true });
                        grid.hideColumn('CreatedLocal', { spans: true });
                        grid.hideColumn('Department', { spans: true });
                        grid.hideColumn('City', { spans: true });
                        grid.hideColumn('BetShop', { spans: true });
                        grid.hideColumn('WayPay', { spans: true });
                        grid.hideColumn('AccountBank', { spans: true });
                        grid.hideColumn('CodeInterbank', { spans: true });
                        grid.hideColumn('Ip', { spans: true });
                        grid.hideColumn('PaymentMethod', { spans: true });
                        grid.showColumn('Country', { spans: true });
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Get start date
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MinCreatedLocal to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Get end date
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MaxCreatedLocal to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for edit start
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                if (item.State == 'A') {
                    // Allow editing if state is 'A'
                } else if (item.State == 'P') {
                    // Allow editing if state is 'P'
                } else {
                    return false; // Prevent editing for other states
                }
                console.log(id);
            }
        });

        // Event listener for edit stop
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row); // Get the edited item
            console.log(item);
            if (state.value != state.old) {
                if (state.value == 'A') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                            '{ "Id":' + item.Id + '}', // Payload for API
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'P'; // Update item state
                                    webix.message('Cell value was changed'); // Success message
                                },
                            },
                        );
                }
                if (state.value == 'P') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/PayWithdrawalRequests',
                            '{ "Id":' + item.Id + '}', // Payload for API
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'I'; // Update item state
                                    webix.message('Cell value was changed'); // Success message
                                },
                            },
                        );
                }
                if (state.value == 'E') {
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/CancelClientRequests',
                            '{ "Id":' + item.Id + '}', // Payload for API
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'E'; // Update item state
                                    webix.message('Cell value was changed'); // Success message
                                },
                            },
                        );
                }
            }
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
